export default __webpack_public_path__ + "static/media/FAQ_9_2.4d88c704.png";